import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getUserReport(userReportId: string): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/reports/user-report/${userReportId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  getReportProjectFiles(reportId: string, projectId: string): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/reports/${reportId}/projects/${projectId}/files`, {
      showLoader: true,
      showMessage: false
    });
  }
}
